var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('div',{staticClass:"contenedor-selectores"},[_c('div',{staticClass:"selectores container main"},[_c(_setup.SelectorVariantes,{staticClass:"selector"}),_c(_setup.SelectorEstados,{staticClass:"selector"})],1)]),_c('div',{staticClass:"selectores-antisombra"}),_c('div',{staticClass:"selectores-sombra"})])
}
var staticRenderFns = []

export { render, staticRenderFns }